import '@babel/polyfill';
require('intersection-observer');

import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import dotenv from 'dotenv';
import store from './store/index';

import estilosT from "./assets/demo5/sass/style.scss";

import VeeValidate, { Validator } from 'vee-validate';
import VueMaterial from 'vue-material';

import es from 'vee-validate/dist/locale/es';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import moment from 'moment';
import BootstrapVue from 'bootstrap-vue';
import VueIziToast  from "vue-izitoast";
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueSweetalert2 from 'vue-sweetalert2';
import VueAnalytics from 'vue-analytics';
import VueTheMask from 'vue-the-mask';
import './servicios/configuracion';
import constantes from "./constantes";



moment.locale("es");

Vue.use(VueMaterial);
Vue.use(VueIziToast);
Vue.use(estilosT);
Vue.use(BootstrapVue);
Vue.use(VueTheMask);

Vue.component('GmapCluster', GmapCluster);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_KEY,
    libraries: 'places,geometry',
    language: 'es'
  }
});
Validator.extend('ci', {
  getMessage:(field )=> `El campo ${field} debe ser una identificación válida`,
  validate:(value,arg)=> constantes.funciones.validarCi(value,arg)
});
Validator.extend('lst', {
  getMessage:(field,num)=> `${field} debe tener mínimo ${num} registros`,
  validate:(value,num)=> constantes.funciones.validarArray(value,num)
});
Validator.extend('obj', {
  getMessage:(field )=> `El campo ${field} no es válido`,
  validate:(value)=> constantes.funciones.validarObje(value)
});




Vue.use(VeeValidate,{
  events: 'change|blur'
});
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALITICS_KEY
});



Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_KEY });
Validator.localize('es', es);
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

dotenv.config();


Vue.use(VueSweetalert2,{
  confirmButtonColor: '#05141f',
});
new Vue({
  router:router,
  store:store,
  render: h => h(App),
}).$mount('#app');
